import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import FormPage from './components/FormPage';
import PayPage from './components/PayPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/form" element={<FormPage />} />
        <Route path="/pay/:id" element={<PayPage />} />
      </Routes>
    </Router>
  );
}

export default App;
